<template>
    <div class="table-row-cells">
        <slot></slot>

        <div class="table-td cell-invite">
            <span>
                {{ moment(patient.inactivated_at).format("D. M. YYYY") }}
                <small>{{ __(":week. week", {week: getWeek}) }}</small>
            </span>
        </div>

        <div class="table-td cell-therapist">
            <user-avatar :user-info="patient.myDoctor.user" size="xs"></user-avatar>

            <span>{{ patient.myDoctor.user | fullname }}</span>
        </div>

        <div v-if="phase === 'inactive_connected'" class="table-td cell-therapist">
            <user-avatar :user-info="patient.myCoach.user" size="xs"></user-avatar>

            <span>{{ patient.myCoach.user | fullname }}</span>
        </div>

        <div v-if="phase === 'inactive_connected'" class="table-td cell-call">
            <span class="indicator-item">
                <consultation-call-status :call_list="patient.consultations_info"></consultation-call-status>
            </span>
        </div>

         <div class="table-td cell-institution width-double">
            <span>
                <figure>
                    <img :src="patient.myDoctor.institution.icon" :alt="patient.myDoctor.institution.name" id="profile-img" height="38" width="38">
                </figure>

                <span>{{ patient.myDoctor.institution.name }}</span>
            </span>
        </div>
    </div>
</template>

<script>
import PatientRowCells from '@components/PatientsMatrix/PatientRowCells'

export default {
    extends: PatientRowCells,
    props: {
        phase: {
            type: String,
            required: false
        }
    },
    computed: {
        getWeek() {
            return moment(this.patient.inactivated_at).diff(this.patient.programme_start, 'weeks') + 1
        }
    }
}
</script>
